import { AVAILABLE_BILL_MODALS } from './consts';

export const BILL_MODALS_STYLES = {
  [AVAILABLE_BILL_MODALS.ACTIONS_MENU]: {
    main: 'flex fixed inset-0 w-screen bg-opacity-70 z-50 justify-end',
    content: 'cursor-default block items-start',
    exit: '',
  },
  [AVAILABLE_BILL_MODALS.SPINNER]: {
    main: 'bg-[#000]/[.5] flex fixed inset-0 h-screen w-screen items-center justify-center z-50',
  },
  [AVAILABLE_BILL_MODALS.MARK_AS_PAID]: {
    main: 'bg-bw07 flex fixed inset-0 h-screen w-screen bg-opacity-70 z-50 items-center justify-center',
    content: 'cursor-default block items-start',
    exit: 'absolute top-3 right-3 cursor-pointer z-10',
  },
  [AVAILABLE_BILL_MODALS.MARK_AS_UNPAID]: {
    main: 'bg-bw07 flex fixed inset-0 h-screen w-screen bg-opacity-70 z-50 items-center justify-center',
    content: 'cursor-default block items-start',
    exit: 'absolute top-3 left-3 cursor-pointer z-10',
  },
  [AVAILABLE_BILL_MODALS.MARK_AS_CANCELED]: {
    main: 'bg-bw07 flex fixed inset-0 h-screen w-screen bg-opacity-70 z-50 items-center justify-center',
    content: 'cursor-default block items-start',
    exit: 'absolute top-5 right-5 cursor-pointer z-10',
  },
};
